import { ProjectsSortingValues } from "@/shared/providers/withProjects/useProjectsFilters/types/ProjectsSortingTypes";
export const DEFAULT_PROJECTS_SORTING_OPTION = ProjectsSortingValues.RECENT_PROJECTS;
